import styled from 'styled-components';
import themeGet from '@styled-system/theme-get';

import Image from '../../../../Core/Image';

export const BankingContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  margin: 0.5rem 1rem;
  height: 100%;

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    margin: 4rem 2.75rem;
  }
`;

export const InputContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 1.5rem;
  width: 60%;

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    width: 40%;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    width: 15rem;
  }
`;

export const InputComponent = styled.div`
  width: 30%;

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    width: unset;
  }
`;

export const InputTitle = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 1.15rem;
  p {
    font-size: 1.125rem;
    line-height: 1.25rem;
    flex: 1 0 auto;
    width: 60%;

    @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
      width: 100%;
    }
  }
`;

export const InputBody = styled.div`
  margin-bottom: 2.35rem;
  p {
    font-size: 0.875rem;
    color: ${themeGet('colors.secondary-text')};
  }
`;

export const StyledImage = styled(Image)`
  width: 1.4rem;
  height: 1.4rem;
  margin-right: 1rem;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    width: 1.75rem;
    height: 1.75rem;
  }
`;

export const Currency = styled.div`
  display: flex;
  justify-content: flex-end;
  position: relative;

  &:before {
    display: ${({ locale }) => (locale === 'en' ? 'flex' : 'none')};
    position: absolute;
    content: '$';
    font-size: 1.5rem;
    margin-right: 0.5rem;
    align-items: center;
    color: ${themeGet('colors.secondary-text')};
    width: auto;
    height: 2.8125rem;
    left: -1.25rem;
  }

  &:after {
    display: ${({ locale }) => (locale === 'fr' ? 'flex' : 'none')};
    position: absolute;
    content: '$';
    font-size: 1.5rem;
    align-items: center;
    color: ${themeGet('colors.secondary-text')};
    width: auto;
    height: 2.8125rem;
    right: -0.75rem;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    &:before {
      margin-right: 1rem;
    }

    &:after {
      right: -1.5rem;
    }
  }
`;

export const Legend = styled.p`
  font-size: 1rem;
  text-align: right;
  margin-bottom: 1.5rem;

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    display: none;
  }
`;
